export const setUserData = (state, value) => {
  state.user = value.user
  state.operator = value.operator
  state.operator2 = value.operator2
  state.signature = value.signature
  state.groups = value.groups
  state.providers = value.providers
  state.orgStructure = value.orgStructure
  state.ts = value.ts
}

export const editProfile = (state, value) => {
  state.user.name = value.name
  state.signature = value.signature
  state.user.emailFrom = value.emailFrom
  state.user.emailFromName = value.emailFromName
}

// Статусы оператора
export const setStatus = (state, value) => {
  state.status = value
}

// Текущий статус оператора
export const operatorStatus = (state, value) => {
  state.operatorStatus = value || null
}

export const setConnection = (state, value) => {
  state.connection = value
}

// Текущий Issue
export const currentIssue = (state, value) => {
  state.currentIssue = value || null
}

// Точка текущего запроса
export const currentIssuePosId = (state, value) => {
  state.currentIssuePosId = value || null
}

// Статус текущего запроса
export const currentIssueOpen = (state, value) => {
  state.currentIssueOpen = value || null
}

// Статусы заказа
export const orderStatuses = (state, value) => {
  state.orderStatuses = value || []
}
